import { faCheck, faPencil, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Components/Atoms/Button/Button';
import { useEffect, useState } from 'react';
import ButtonGroup from '../ButtonGroup/ButtonGroup';

const EditButton = ({
    isEdit, isLoading: rawLoading, isDisabled = false,
    onChange, onSave,
    variant
}: Props) => {
    const handleCancel = () => {
        onChange(false);
        setLoading(false);
    }
    const handleEdit = () => {
        onChange(true);
        setLoading(false);
    };
    const handleSave = () => {
        setLoading(true);
        onSave();
    };

    const [isLoading, setLoading] = useState(rawLoading);
    useEffect(() => {
        if (!rawLoading) handleCancel();
        setLoading(rawLoading);
    }, [rawLoading]);

    return <ButtonGroup>
        {
            !isEdit &&
            <Button
                size='small'
                iconBefore={<FontAwesomeIcon icon={faPencil} />}
                onClick={handleEdit}
                isDisabled={isDisabled}
            >
                Aanpassen
            </Button>
        }
        {
            isEdit &&
            <>
                {
                    !isLoading &&
                    <Button
                        variant='transparent'
                        size='small'
                        iconBefore={<FontAwesomeIcon icon={faXmark} />}
                        onClick={handleCancel}
                    >
                        Annuleren
                    </Button>
                }
                <Button
                    variant='solid'
                    size='small'
                    iconBefore={<FontAwesomeIcon icon={faCheck} />}
                    onClick={handleSave}
                    isLoading={isLoading}
                    isDisabled={isDisabled}
                >
                    Opslaan
                </Button>
            </>
        }
    </ButtonGroup>
}

interface Props {
    variant: 'button'
    
    isEdit: boolean
    isLoading?: boolean
    isDisabled?: boolean

    onChange: any
    onSave: any
}

export default EditButton;